<p-toast />
<div class="outer-container">
  <app-current-path></app-current-path>
  <div class="console-container">
    <form [formGroup]="addnewCampaignForm">
      <div class="name-container">
        @if (submitted && this.addnewCampaignForm.invalid) {
          <div class="text-danger label-error">
          
            <small>Please fill all the required fields before proceeding further !!</small>
          </div>
          }
        <span class="action-name">{{ title }}</span>
        <input
          class="btn btn-default cst-btn"
          type="submit"
          value="Save Changes"
         
          (click)="onSubmit()"
        />
        <!-- [disabled]="!addnewCampaignForm.valid || disableAllInputs || disableSaveBtn||addnewCampaignForm.invalid" -->
        <!--[disabled]="(!isEdit && addnewCampaignForm.invalid) || disableAllInputs"-->
        <button
          *ngIf="!isEdit"
          class="btn btn-danger btn-cancel"
          (click)="goBack()"
          style="float: right; margin-top: 0.4rem; margin-right: 0.7rem"
        >
          Cancel
        </button>
        <button *ngIf="isEdit" class="btn btn-default cst-btn" (click)="goBack()" style="margin-right: 0.7rem">
          Go Back
        </button>
        <!-- <button class="btn btn-default cst-btn" (click)="findInvalidControls()">Validate</button> -->
      </div>
      <div class="details">
        <div class="heading">
          <span class="section-heading">CAMPAIGN DETAILS</span>

          <hr class="solid-divider" />
        </div>
        <div class="row crud-container">
          <div class="form-group form-field-edit">
            <label class="required form-field-label" for="campaignName">Name</label>
            <input type="text" class="form-control inp" id="campaignName" placeholder="Name" formControlName="name" />
            @if (submitted && f['name'].errors) {
              <div class="text-danger label-error">
                @if (f['name'].errors['required']) {
                <small>Name is required</small>
                }
              </div>
              }
          </div>

          <div class="form-group form-field-edit">
            <label for="campaignDescription" class="form-field-label">Description</label>
            <input
              type="text"
              class="form-control inp"
              id="campaignDescription"
              placeholder="Description"
              formControlName="description"
            />
          </div>

          <div class="form-group form-field-edit">
            <label class="form-field-label" for="crmCampaignID">CRM Campaign ID</label>
            <input
              type="text"
              class="form-control inp"
              id="crmCampaignID"
              placeholder="CRM Campaign ID"
              formControlName="crmCampaignID"
            />
          </div>
        </div>

        <div class="row crud-container">
          <div class="form-group form-field-edit">
            <label class="required search-label form-field-label" for="channeldropdown">Channel</label>
            <select id="channeldropdown" class="inp" formControlName="channel" (change)="onChannelChange()">
              <ng-container *ngFor="let item of channels">
                <option [value]="item.value" [defaultSelected]="campaignDetail?.Channel == item.value">
                  {{ item.label }}
                </option>
              </ng-container>
            </select>
            @if (submitted && f['channel'].errors) {
              <div class="text-danger label-error">
                @if (f['channel'].errors['required']) {
                <small>Channel is required</small>
                }
              </div>
              }
          </div>

          <div class="form-group form-field-edit">
            <label class="search-label form-field-label" for="channelTypedropdown">Campaign Type</label>
            <select id="channelTypedropdown" class="inp" formControlName="type">
              <ng-container *ngFor="let item of campaignTypes">
                <option [value]="item.value" [defaultSelected]="campaignDetail?.CampaignTypeId == item.value">
                  {{ item.label }}
                </option>
              </ng-container>
            </select>
          </div>
        </div>

        <div class="row crud-container" *ngIf="isEdit">
          <div class="form-group form-field-nonedit">
            <label for="status" class="form-field-label">Status</label>
            <input
              type="text"
              [readonly]="true"
              class="form-control inp"
              id="status"
              placeholder="Status"
              [value]="campaignDetail?.Status"
            />
          </div>

          <div class="form-group form-field-nonedit">
            <label for="createdOn" class="form-field-label">Created On</label>
            <input
              type="text"
              [readonly]="true"
              class="form-control inp"
              id="createdOn"
              placeholder="Created On"
              [value]="campaignDetail?.Created | custdate"
            />
          </div>

          <div class="form-group form-field-nonedit">
            <label for="lastUpdatedOn" class="form-field-label">Last Updated On</label>
            <input
              type="text"
              [readonly]="true"
              class="form-control inp"
              id="lastUpdatedOn"
              placeholder="Last Updated On"
              [value]="campaignDetail?.LastUpdated | custdate"
            />
          </div>
        </div>

        <div class="row crud-container">
          <div class="form-check mt-1 fs-14">
            <input
              class="form-check-input custom-checkbox"
              type="checkbox"
              id="flexCheckChecked"
              formControlName="customLogging"
            />
            <label class="form-check-label log-call" for="flexCheckChecked"> Log Calls to API </label>
          </div>
        </div>

        <div class="row crud-container" *ngIf="campaignDetail?.Status === 'Paused'" >
          <div class="form-group no-padding">
            <button class="btn btn-default blue-outline-btn" style="float: left" (click)="resumeCampaign()">Resume</button>
            <button class="btn btn-danger btn-cancel" style="float: left" (click)="cancelCampaign()">Cancel</button>
          </div>
        </div>

        <div class="row crud-container" *ngIf="campaignDetail?.Status === 'InProgress'">
          <div class="form-group no-padding">
            <button class="btn btn-warning btn-pause" style="float: left" (click)="pauseCampaign()">Pause</button>
          </div>
        </div>

        <div class="row crud-container" *ngIf="campaignDetail?.Status === 'Ready'">
          <div class="form-group no-padding">
            <button class="btn btn-success btn-pause" style="float: left" (click)="startCampaign()">Start</button>
          </div>
        </div>
      </div>

      <!------------ Section 2 ---------->
      <div class="details">
        <div class="heading">
          <span class="section-heading">PHONE CALL CONFIGURATION</span>
          <hr class="solid-divider" />
        </div>

        <div class="row crud-container">
          <div class="col-8 padl-0">
            <div class="row form-group form-field-edit">
              <label class="required search-label form-field-label label-blue padl-0" for="callFrom">Call From</label>
              <select id="callFrom" class="inp" formControlName="callFrom">
                <ng-container *ngFor="let item of phoneNumbers">
                  <option
                    [value]="item.value"
                    [defaultSelected]="campaignDetail?.CampaignRun?.OutboundPhoneNumber == item.value"
                  >
                    {{ item.label }}
                  </option>
                </ng-container>
              </select>
             
            </div>
            @if (submitted && f['callFrom'].errors) {
              <div class="text-danger label-error" style="
              margin: -9px 9px 0px 4px;
          ">
                @if (f['callFrom'].errors['required']) {
                <small>CallFrom is required</small>
                }
              </div>
              }
            <div>
              <div class="row crud-container mt-1">
                <div class="col-2 padl-0" style="width: 15%">
                  <label class="required checkbox-inline sub-heading">Available On</label>
                </div>
                <div class="col form-group">
                  <label
                    class="col-md-1 cbl week-label"
                    for="checkboxes-0"
                    *ngFor="let day of availableOnDays; let i = index"
                    formArrayName="selectedDays"
                  >
                    <input
                      class="form-check-input custom-checkbox"
                      type="checkbox"
                      name="checkboxes"
                      id="{{ i }}"
                      [formControlName]="i"
                      [checked]="day.checked"
                    />
                    {{ day.label }}
                  </label>
                  @if (submitted && (selectedDays.length <= 0 )) {
                    <div class="text-danger label-error">
                      <!-- @if (f['name'].errors['required']) { -->
                      <small>Available On is required</small>
                      <!-- } -->
                    </div>
                    }
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="col"></div> -->

          <div
            class="input-group col-3 test-call"
            *ngIf="!isTextChannelSelected && isEdit && !(campaignDetail?.Status === 'Complete' || campaignDetail?.Status === 'Cancelled')"
          >
            <label class="search-label test-call-label" for="testCall">Make a Test Call</label><br />
            <div class="input-group btn btn-outline-default btn-sm call-option" [ngClass] = "calloptionWidth">
              <select
                [(ngModel)]="selectedType"
                (change)="onSelectionChange($event)"
                [ngModelOptions]="{ standalone: true }"
                class="select-phone"
              >
                <option *ngFor="let type of phoneTypes" [value]="type">{{ type }}</option>
              </select>
              <input
                type="text"
                [readonly]="isReadOnly"
                (keypress)="numbersOnly($event)"
                class="input-pnone-number"
                [(ngModel)]="phoneNumber"
                [ngModelOptions]="{ standalone: true }"
                [ngClass] = "txtphonenumberwidth"
              />
            </div>
              <div *ngIf = "isPlaying"
                class="img-btn1 img-dialer"
                alt="Dialer"
                title="Keypad"
                [ngClass]="{ disabled: !dialbtn_enabled }"
                (click)="showKeypad()"
              ></div>
                
                <div *ngIf = "isPlaying"
                class="img-btn img-mute"
                alt="Mute/Unmute"
                [title]="isMicMute ? 'Unmute' : 'Mute'"
                [ngClass]="{ disabled: !mutebtn_enabled || onHold, active: isMicMute }"
                (click)="mute(isMicMute)"
              ></div>
              
          <img
                alt="call"
                class="img-fluid"
                style="width: 2.2rem; height: 2.2rem;"
                [src]="isHardPhonePlaying"
                (click)="StartTestPhoneCall()"
              />
              <div class =" keypad-row"*ngIf="keypad">
                <ng-container *ngFor="let item of numberPad">
                  <div class="keypad " (click)="onNumberPadBtnClick(item.number)">
                    <div class="digits">{{ item.digit }}</div>
                    <div class="numbers">{{ item.number }}</div>
                  </div>
                </ng-container>
              </div>
          </div>
          <div
            class="input-group col-3 test-call"
            *ngIf="isTextChannelSelected && isEdit && !(campaignDetail?.Status === 'Complete' || campaignDetail?.Status === 'Cancelled')"
          >
            <label class="search-label test-call-label" for="testCall">Send Test Text</label><br />
            <div class="sendTestText">
            <div class="input-group btn btn-outline-default btn-sm sms-option">
              <input
                type="text"
                (keypress)="numbersOnly($event)"
                class="input-pnone-number sms-number"
                [(ngModel)]="smsPhoneNumber"
                [ngModelOptions]="{ standalone: true }"
              />
              
            </div>
            <button class="btn btn-success btn-send" (click)="sendSMS()">Send</button>
          </div>
            
          </div>
        </div>

        <div class="row crud-container mt-1">
          <div class="col-1 padl-0" style="padding-top: 0.5rem; width: 11%">
            <label class="required checkbox-inline sub-heading">Time Between</label>
          </div>

          <div class="form-group w-10">
            <!-- <div class="form-group">
              <label for="startTime" class="form-field-label label-blue">Start Time</label>
             
               <div class="input-group date" id="startTime">
                <input
                  type="time"
                  class="form-control timePicker inp pad-0"
                  formControlName="activeStartTime"
                  (change)="validateTimeRange()"
                />
              </div> 
            </div> -->
            <div class="form-group inp-time">
              <label for="starttime" class="timepicker-label">Start Time</label>
              <!--<input name="starttime" type="time" [ngModel]="savedData.activeStartTime" class="form-control" class='inp' id="starttime" placeholder=""
                                [value]="">-->
              <!-- <p-calendar
                [showTime]="true"
                [timeOnly]="true"
                hourFormat="24"
                [iconDisplay]="'input'"
                [showIcon]="true"
                formControlName="activeStartTime"
                (onSelect)="validateTimeRange()"
              >
              </p-calendar> -->
              <p-calendar
                [showTime]="true"
                [timeOnly]="true"
                hourFormat="12"
                formControlName="activeStartTime"
                [iconDisplay]="'input'"
                [showIcon]="true"
                (onSelect)="validateTimeRange()"
              >
              </p-calendar>
            
            </div>
            @if (submitted && f['activeStartTime'].errors) {
              <div class="text-danger label-error">
                @if (f['activeStartTime'].errors['required']) {
                <small>StartTime is required</small>
                }
              </div>
              }
          </div>

          <div class="form-group w-10">
            <!-- <div class="form-group">
              <label for="endTime" class="form-field-label label-blue">End Time</label>
              <div class="input-group date" id="endTime">
                <input
                  type="time"
                  class="form-control timePicker inp pad-0"
                  formControlName="activeEndTime"
                  (change)="validateTimeRange()"
                />
              </div>
            </div> -->
            <div class="form-group inp-time">
              <label for="starttime" class="timepicker-label">End Time</label>
              <!--<input name="starttime" type="time" [ngModel]="startTime" class="form-control" class='inp' id="starttime" placeholder=""
                                [value]="">-->
              <p-calendar
                [showTime]="true"
                [timeOnly]="true"
                hourFormat="12"
                formControlName="activeEndTime"
                [iconDisplay]="'input'"
                [showIcon]="true"
                (onSelect)="validateTimeRange()"
              >
              </p-calendar>
             
            </div>
            @if (submitted && f['activeEndTime'].errors) {
              <div class="text-danger label-error">
                @if (f['activeEndTime'].errors['required']) {
                <small>EndTime is required</small>
                }
              </div>
              }
          </div>
          <label class="time-validation-msg" *ngIf="timeValidationMessage">
            {{ timeValidationMessage }}</label>
        </div>

        <div class="row crud-container mt-1">
          <div class="form-group form-field-edit">
            <label
              class="required search-label timepicker-label"
              style="padding: 0rem; padding-top: 0.3rem"
              for="channelTypedropdown"
              >Time Zone</label
            >
            <select id="channelTypedropdown" class="inp" formControlName="activeTimeZone">
              <ng-container *ngFor="let item of timeZones">
                <option [value]="item.value">{{ item.label }}</option>
              </ng-container>
            </select>
           
          </div>
          @if (submitted && f['activeTimeZone'].errors) {
            <div class="text-danger label-error" style="
            margin: -10px 0 0 -7px;
        ">
              @if (f['activeTimeZone'].errors['required']) {
              <small>TimeZone is required</small>
              }
            </div>
            }
        </div>
        <div class="row crud-container" *ngIf="addnewCampaignForm.get('channel').value == 1">
          <div class="form-group form-field-edit">
            <label class="required search-label form-field-label label-blue" for="attempts">Attempts</label>
            <select id="attempts" class="inp" formControlName="attempts" (change)="onAttemptsChange()">
              <ng-container *ngFor="let item of [].constructor(6); let i = index">
                <option [value]="i + 1">{{ i + 1 }}</option>
              </ng-container>
            </select>
            @if (submitted && f['attempts'].errors) {
              <div class="text-danger label-error">
                @if (f['attempts'].errors['required']) {
                <small>Attempts is required</small>
                }
              </div>
              }
          </div>
          
          <div class="form-group form-field-edit" *ngIf="addnewCampaignForm.get('attempts').value > 1">
            <label class="required search-label form-field-label" for="attemptsInterval">Time Between Attempts</label>
            <select id="attemptsInterval" class="inp" formControlName="attemptsInterval">
              <ng-container *ngFor="let item of timeIntervals">
                <option [value]="item.value">{{ item.label }}</option>
              </ng-container>
            </select>
            @if (submitted && f['attemptsInterval'].errors) {
              <div class="text-danger label-error">
                @if (f['attemptsInterval'].errors['required']) {
                <small>Time Between Attempts is required</small>
                }
              </div>
              }
          </div>
          
        </div>
      </div>

      <!------------ Section 3 ---------->
      <div class="details" style="margin-bottom: 1rem">
        <div class="heading">
          <span class="section-heading">MESSAGE PROMPT SETTINGS</span>
          <hr class="solid-divider" />
        </div>
        <!--------------------------------Add------------------------------------------------------------>
        <ng-container *ngIf="!isEdit && addnewCampaignForm.get('channel').value == 1">
          <div class="row crud-container" *ngIf="!showAddMessage">
            <div class="form-group padl-0">
              <span class="sub-sub-heading mr-5">Message</span>
              <button
                class="btn btn-default blue-outline-btn"
                [disabled]="disableAllInputs"
                (click)="showAddMessage = true"
              >
                Add Message 
              </button>
              <div class="spacing"></div>
              <span class="text-danger label-error" *ngIf='errorVoiceMsg'>{{errorVoiceMsg}}</span>
            </div>
          </div>
          <ng-container *ngIf="showAddMessage">
            <div class="row crud-container">
              <div class="form-group btn-group-camp btn-group-camp">
                <span class="sub-sub-heading mr-5">Message</span>
                <button *ngIf="false"
                  class="btn btn-danger btn-cancel mr-07"
                  [disabled]="disableAllInputs"
                  (click)="messagePromptSettingsCancel()"
                >
                  Cancel
                </button>
                <button
                  class="btn btn-default blue-outline-btn mr-07"
                  [disabled]="disableAllInputs || disablePreviewBtn"
                  *ngIf="isSoftphoneOnly && addnewCampaignForm.get('channel').value && showPreviewBtn"
                  (click)="previewMessage()"
                >
                  {{ previewBtnText }}
                </button>
                <button *ngIf="previewBtnText==='Playing'"
                  class="btn btn-danger btn-cancel mr-07"
                  (click)="cancelPreview()"
                >
                  Cancel
                </button>
                
              </div>
            </div>
            <div class="row crud-container">
              <div class="form-group form-field-edit" *ngIf="campaignDetail?.Status !== 'Complete'">
                <label class="required search-label" class="form-field-label label-blue" for="messageSource"
                  >Message Source</label
                >
                <select
                  id="messageSource"
                  class="inp"
                  formControlName="messageSource"
                  (change)="onMessageSourceChange()"
                >
                  <ng-container *ngFor="let item of messageSources">
                    <option [value]="item.value">{{ item.label }}</option>
                  </ng-container>
                </select>
              
              </div>
              @if (submitted && f['messageSource'].errors) {
                <div class="text-danger label-error" style="margin: -10px 0 0 -7px;">
                  @if (f['messageSource'].errors['required']) {
                  <small>MessageSource is required</small>
                  }
                </div>
                }

              <div
                class="form-group form-field-edit "
               
                *ngIf="addnewCampaignForm.get('messageSource').value === 'uploadfile'"
              >
              <div class="choose-file-div">
                <div>
                  <label class="choose-file"> Choose File
                    <input style="display: none;" class="form-control file-upload" type="file" id="formFile" (change)="handleFileInput($event)" />
                  </label>
                </div>
                <div
                  *ngIf="addnewCampaignForm.get('messageSource').value === 'uploadfile' && savingAudioFileMessage"
                  [ngClass]="{
                    loadingDotAnimation: savingAudioFileMessage === 'Saving File',
                  }"
                  class="audio-timer fs-hint" title="{{savingAudioFileMessage}}"
                >
                  {{savingAudioFileMessage.length>30?(savingAudioFileMessage|slice:0:25)+'...' : savingAudioFileMessage }}
                </div>
              </div>
                @if (submitted && f['messageDescription'].errors) {
                  <div class="text-danger label-error" style="margin: 10px 0 0 0px;">
                    @if (f['messageDescription'].errors['required']) {
                    <small>Please Upload a file</small>
                    }
                  </div>
                  }
              </div>

              <div
                class="form-group form-field-edit"
                style="height: 4.5rem"
                *ngIf="addnewCampaignForm.get('messageSource').value === 'texttospeech'"
              >
                <label class="required search-label form-field-label" for="messageDescription">Message Text</label>
                <input
                  type="text"
                  class="form-control inp pad-0"
                  id="messageDescription"
                  formControlName="messageDescription"
                  style="display: none"
                />
                <input
                  type="text"
                  class="form-control inp pad-0"
                  id="ttsMessage"
                  formControlName="ttsMessage"
                  style="display: none"
                />
                <textarea class="form-control inp pad-0" id="ttsMessage" formControlName="ttsMessage"></textarea>
                <div style="margin: 11px 0px 0px -1px;">
                  @if (submitted && f['ttsMessage'].errors) {
                    <div class="text-danger label-error">
                      @if (f['ttsMessage'].errors['required']) {
                      <small>TtsMessage is required</small>
                      }
                    </div>
                    }
                </div>
              </div>
             
              <div
                class="form-group form-field-edit"
                *ngIf="addnewCampaignForm.get('messageSource').value === 'customapi'"
              >
                <label class="search-label" for="apiMethod">API Method</label>
                <select id="apiMethod" class="inp" formControlName="apiMethod">
                  <ng-container *ngFor="let item of ivrPromptAPIMethods">
                    <option [value]="item.value">{{ item.label }}</option>
                  </ng-container>
                </select>
              </div>

              <div class="form-group col padl-0" *ngIf="addnewCampaignForm.get('messageSource').value === 'recording'">
                <button class="btn btn-danger btn-cancel record-btn" *ngIf="!isRecording" (click)="startRecording()">
                  Record
                </button>
                <button class="btn btn-danger btn-cancel record-btn" *ngIf="isRecording" (click)="stopRecording()">
                  Stop
                </button>

                <span class="audio-timer" *ngIf="isRecording && !blobUrl">
                  {{ recordedTime }}
                </span>
                <div class="audio-timer" style="top: 0.125rem" *ngIf="savingRecordingFileMessage">
                  {{ savingRecordingFileMessage }}
                </div>
                @if (submitted && f['messageDescription'].errors) {
                  <div class="text-danger label-error" style="margin: -2px 0 0 0px;">
                    @if (f['messageDescription'].errors['required']) {
                    <small>Please record a message</small>
                    }
                  </div>
                  }
                <!-- <audio class="audio-player" *ngIf="!isRecording && blobUrl" controls>
                                        <source [src]="blobUrl" type="audio/webm">
                                    </audio> -->
              </div>
            </div>

            <div class="row crud-container">
              <div class="form-group form-field-edit">
                <label class="required search-label" class="form-field-label label-blue" for="playMessage"
                  >Play Message</label
                >
                <select id="playMessage" class="inp" formControlName="playMessage">
                  <ng-container *ngFor="let item of [].constructor(5); let i = index">
                    <option [value]="i + 1">{{ i + 1 }} times</option>
                  </ng-container>
                </select>
               
              </div>
              @if (submitted && f['playMessage'].errors) {
                <div class="text-danger label-error" style="margin: -10px 0 0 -7px;">
                  @if (f['playMessage'].errors['required']) {
                  <small>PlayMessage is required</small>
                  }
                </div>
                }

              <div class="form-group form-field-edit">
                <label class="search-label" class="form-field-label label-blue" for="actionKey">Action Key</label>
                <select id="actionKey" class="inp" formControlName="actionKey" (change)="onActionKeyChange()">
                  <option [value]="'Default'">Default</option>
                  <option [value]="'None'">None</option>
                  <option [value]="'*'">*</option>
                  <ng-container *ngFor="let item of [].constructor(10); let i = index">
                    <option [value]="i">{{ i }}</option>
                  </ng-container>
                </select>
              </div>

              <div class="form-group form-field-edit">
                <label class="search-label" for="actionKey">Estimated Response Rate</label>
                <input
                  type="text"
                  class="form-control inp"
                  id="response-rate"
                  placeholder=""
                  formControlName="responseRate"
                /><label style="position: relative; top: -1.375rem; right: -305px">%</label>
              </div>
            </div>

            <div class="row crud-container" *ngIf="addnewCampaignForm.get('actionKey').value !== 'None'">
              <div class="form-group form-field-edit">
                <label class="required search-label form-check-label" for="responseQueue">Response Queue</label>
                <select id="responseQueue" class="inp" formControlName="responseQueue">
                  <ng-container *ngFor="let item of responseQueues">
                    <option [value]="item.value">{{ item.label }}</option>
                  </ng-container>
                </select>
                @if (submitted && f['responseQueue'].errors) {
                  <div class="text-danger label-error">
                    @if (f['responseQueue'].errors['required']) {
                    <small>ResponseQueue is required</small>
                    }
                  </div>
                  }
              </div>
             

              <div class="form-group form-field-edit">
                <label class="required search-label form-field-label" for="responseQueueIVRPrompts"
                  >Response Queue IVR Prompt</label
                >
                <select id="responseQueueIVRPrompts" class="inp" formControlName="responseQueueIVRPrompts">
                  <ng-container *ngFor="let item of responseQueueIVRPrompts">
                    <optgroup label="{{item.type}}">
                      <option [value]="item.value">{{ item.label }}</option>
                    </optgroup>
                  </ng-container>
                </select>
                @if (submitted && f['responseQueueIVRPrompts'].errors) {
                  <div class="text-danger label-error" >
                    @if (f['responseQueueIVRPrompts'].errors['required']) {
                    <small>ResponseQueueIVRPrompts is required</small>
                    }
                  </div>
                  }
              </div>
             

              <div class="form-group form-field-edit">
                <label class="search-label form-field-label" for="response-skills">Response Skills</label>
                <select id="response-skills" class="inp" formControlName="responseSkill">
                  <ng-container *ngFor="let item of responseSkills">
                    <option [value]="item.value">{{ item.label }}</option>
                  </ng-container>
                </select>
              </div>
            </div>
          </ng-container>
        </ng-container>
        <!----------------------------------------------------------Edit-------------------------------------------->
        <ng-container *ngIf="isEdit && addnewCampaignForm.get('channel').value == 1">
          <div class="row crud-container">
            <div class="form-group btn-group-camp" *ngIf="campaignDetail?.Status !== 'Complete'">
              <span class="sub-sub-heading mr-5">Message</span>
              <button
                *ngIf="showEditMessage"
                class="btn btn-default blue-outline-btn mr-07"
                [disabled]="disableAllInputs"
                (click)="showEditMessage = !showEditMessage"
              >
                Edit Message
              </button>

              <button
                *ngIf="false && !showEditMessage"
                class="btn btn-danger btn-cancel mr-07"
                [disabled]="disableAllInputs"
                (click)="showEditMessage = !showEditMessage; cancelMessageSourceEdit()"
              >
                Cancel
              </button>

              <button
                class="btn btn-default blue-outline-btn"
                [disabled]="disableAllInputs || disablePreviewBtn"
                *ngIf="isSoftphoneOnly && addnewCampaignForm.get('channel').value && showPreviewBtn"
                (click)="previewMessage()"
              >
                {{ previewBtnText }}
              </button>
              <button *ngIf="previewBtnText==='Playing'"
                  class="btn btn-danger btn-cancel mr-07"
                  (click)="cancelPreview()"
                >
                  Cancel
                </button>
            </div>
          </div>
          <ng-container>
            <!-- <div class="row crud-container" *ngIf="!showEditMessage">
                            <div class="form-group">
                                <span class="sub-sub-heading">Message</span>
                                <button class="btn btn-danger update-btn" [disabled]="disableAllInputs"
                                    (click)="showEditMessage = !showEditMessage">
                                    Cancel</button>
                            </div>
                        </div> -->
            <div class="row crud-container">
              <div class="form-group form-field-edit" *ngIf="campaignDetail?.Status !== 'Complete' && !showEditMessage">
                <label class="required search-label form-field-label" for="messageSource">Message Source</label>
                <select
                  id="messageSource"
                  class="inp"
                  formControlName="messageSource"
                  (change)="onMessageSourceChange()"
                >
                  <ng-container *ngFor="let item of messageSources">
                    <option [value]="item.value">{{ item.label }}</option>
                  </ng-container>
                </select>
               
              </div>
              @if (submitted && f['messageSource'].errors) {
                <div class="text-danger label-error" style="margin: -10px 0 0 -7px;">
                  @if (f['messageSource'].errors['required']) {
                  <small>MessageSource is required</small>
                  }
                </div>
                }

              <div
                class="form-group form-field-edit "
                
                *ngIf="addnewCampaignForm.get('messageSource').value === 'uploadfile' && !showEditMessage"
              >
              <div class="choose-file-div">
                <div>
                  <label class="choose-file"> Choose File
                    <input style="display: none;" class="form-control file-upload" type="file" id="formFile" (change)="handleFileInput($event)" />
                  </label>
                </div>
                <div
                  *ngIf="addnewCampaignForm.get('messageSource').value === 'uploadfile' && savingAudioFileMessage"
                  [ngClass]="{
                    loadingDotAnimation: savingAudioFileMessage === 'Saving File',
                  }"
                  class="audio-timer fs-hint"
                  title="{{ addnewCampaignForm.get('messageDescription').value }}"
                >
                  {{
                    savingAudioFileMessage.length > fileNameMaxLenth
                      ? (savingAudioFileMessage | slice: 0 : fileNameMaxLenth) + '...'
                      : savingAudioFileMessage
                  }}
                </div>
              </div>
                @if (submitted && f['messageDescription'].errors) {
                  <div class="text-danger label-error" style="margin: 10px 0 0 0px;">
                    @if (f['messageDescription'].errors['required']) {
                    <small>Please Upload a file</small>
                    }
                  </div>
                  }
              </div>
             
              <div
                class="form-group form-field-edit"
                style="height: 4.5rem"
                *ngIf="addnewCampaignForm.get('messageSource').value === 'texttospeech' && !showEditMessage"
              >
                <label class="required search-label form-field-label" for="messageDescription">Message Text</label>
                <input
                  type="text"
                  class="form-control inp pad-0"
                  id="messageDescription"
                  formControlName="messageDescription"
                  style="display: none"
                />
                <input
                  type="text"
                  class="form-control inp pad-0"
                  id="ttsMessage"
                  formControlName="ttsMessage"
                  style="display: none"
                />
                <textarea class="form-control inp pad-0" id="ttsMessage" formControlName="ttsMessage"></textarea>
                <div style="margin: 11px 0px 0px -1px;">
                  @if (submitted && f['ttsMessage'].errors) {
                    <div class="text-danger label-error">
                      @if (f['ttsMessage'].errors['required']) {
                      <small>TtsMessage is required</small>
                      }
                    </div>
                    }
                </div>
                
               
  
              </div>
             
              <div
                class="form-group form-field-edit"
                *ngIf="addnewCampaignForm.get('messageSource').value === 'customapi' && !showEditMessage"
              >
                <label class="search-label" for="apiMethod">API Method</label>
                <select id="apiMethod" class="inp" formControlName="apiMethod">
                  <ng-container *ngFor="let item of ivrPromptAPIMethods">
                    <option [value]="item.value">{{ item.label }}</option>
                  </ng-container>
                </select>
              </div>

              <div
                class="form-group col padl-0"
                *ngIf="addnewCampaignForm.get('messageSource').value === 'recording' && !showEditMessage"
              >
                <button class="btn btn-danger btn-cancel record-btn" *ngIf="!isRecording" (click)="startRecording()">
                  Record
                </button>
                <button class="btn btn-danger btn-cancel record-btn" *ngIf="isRecording" (click)="stopRecording()">
                  Stop
                </button>

                <span class="audio-timer" *ngIf="isRecording && !blobUrl">
                  {{ recordedTime }}
                </span>
                <div
                  class="audio-timer"
                  style="top: 0.125rem"
                  *ngIf="savingRecordingFileMessage"
                  title="{{ addnewCampaignForm.get('messageDescription').value }}"
                >
                  {{ savingRecordingFileMessage }}
                </div>
                @if (submitted && f['messageDescription'].errors) {
                  <div class="text-danger label-error" style="margin:-2px 0 0 0px;">
                    @if (f['messageDescription'].errors['required']) {
                    <small>Please record a message</small>
                    }
                  </div>
                  }
                <!-- <audio class="audio-player" *ngIf="!isRecording && blobUrl" controls>
                                        <source [src]="blobUrl" type="audio/webm">
                                    </audio> -->
              </div>
             
            </div>

            <div class="row crud-container">
              <div class="form-group form-field-edit">
                <label class="required search-label form-field-label" for="playMessage">Play Message</label>
                <select id="playMessage" class="inp" formControlName="playMessage">
                  <ng-container *ngFor="let item of [].constructor(5); let i = index">
                    <option [value]="i + 1">{{ i + 1 }} times</option>
                  </ng-container>
                </select>
                
              </div>
              @if (submitted && f['playMessage'].errors) {
                <div class="text-danger label-error" style="margin: -10px 0 0 -7px;">
                  @if (f['playMessage'].errors['required']) {
                  <small>PlayMessage is required</small>
                  }
                </div>
                }

              <div class="form-group form-field-edit">
                <label class="search-label form-field-label" for="actionKey">Action Key</label>
                <select id="actionKey" class="inp" formControlName="actionKey" (change)="onActionKeyChange()">
                  <option [value]="'Default'">Default</option>
                  <option [value]="'None'">None</option>
                  <option [value]="'*'">*</option>
                  <ng-container *ngFor="let item of [].constructor(10); let i = index">
                    <option [value]="i">{{ i }}</option>
                  </ng-container>
                </select>
              </div>

              <div
                class="form-group form-field-edit"
                *ngIf="addnewCampaignForm.get('messageSource').value !== 'Upload File'"
              >
                <label class="search-label form-field-label" for="actionKey">Estimated Response Rate</label>
                <input
                  type="text"
                  class="form-control inp"
                  id="response-rate"
                  placeholder=""
                  formControlName="responseRate"
                /><label style="position: relative; top: -1.375rem; right: -305px">%</label>
              </div>
            </div>

            <div class="row crud-container" *ngIf="addnewCampaignForm.get('actionKey').value !== 'None'">
              <div class="form-group form-field-edit">
                <label class="required search-label form-field-label" for="responseQueue">Response Queue</label>
                <select id="responseQueue" class="inp" formControlName="responseQueue">
                  <ng-container *ngFor="let item of responseQueues">
                    <option [value]="item.value">{{ item.label }}</option>
                  </ng-container>
                </select>
                @if (submitted && f['responseQueue'].errors) {
                  <div class="text-danger label-error" >
                    @if (f['responseQueue'].errors['required']) {
                    <small>ResponseQueue is required</small>
                    }
                  </div>
                  }
  
              </div>
             
              <div class="form-group form-field-edit">
                <label class="required search-label form-field-label" for="responseQueueIVRPrompt"
                  >Response Queue IVR Prompt</label
                >
                <select id="responseQueueIVRPrompts" class="inp" formControlName="responseQueueIVRPrompts">
                  <ng-container *ngFor="let item of responseQueueIVRPrompts">
                    <optgroup label="{{item.type}}">
                      <option [value]="item.value">{{ item.label }}</option>
                    </optgroup>
                  </ng-container>
                </select>
                @if (submitted && f['responseQueueIVRPrompts'].errors) {
                  <div class="text-danger label-error" >
                    @if (f['responseQueueIVRPrompts'].errors['required']) {
                    <small>ResponseQueueIVRPrompts is required</small>
                    }
                  </div>
                  }
              </div>
             

              <div class="form-group form-field-edit">
                <label class="search-label" for="response-skills">Response Skills</label>
                <select id="response-skills" class="inp" formControlName="responseSkill">
                  <ng-container *ngFor="let item of responseSkills">
                    <option [value]="item.value">{{ item.label }}</option>
                  </ng-container>
                </select>
              </div>
            </div>
          </ng-container>
        </ng-container> 
        <div class="row crud-container"  *ngIf="addnewCampaignForm.get('channel').value == 2">
          <div class="form-group form-field-edit"  >
            <label class="required search-label form-field-label" for="messageSource">Message Source</label>
            <select id="ddlmessageTextSource" class="inp" formControlName="messageSource" (change)="onTextSourceChange()">
              <ng-container *ngFor="let item of TextSourceTypes">
                <option [value]="item.value">{{ item.label }}</option>
              </ng-container>
            </select>
            <div style="margin: 11px 0px 0px -1px;">
              @if (submitted && f['messageSource'].errors) {
                <div class="text-danger label-error" >
                  @if (f['messageSource'].errors['required']) {
                  <small>messageSource is required</small>
                  }
                </div>
                }
            </div>
          </div> 
        </div>
        <div class="row crud-container" style="height: 5.5rem" *ngIf="addnewCampaignForm.get('channel').value == 2">
          <div class="form-group form-field-edit" style="height: 75px">
            <label class="required search-label form-field-label" for="messageText">Message Text</label>
            <textarea class="form-control inp pad-0" id="messageText" formControlName="messageText"></textarea>
            <div style="margin: 11px 0px 0px -1px;">
              @if (submitted && f['messageText'].errors) {
                <div class="text-danger label-error" >
                  @if (f['messageText'].errors['required']) {
                  <small>MessageText is required</small>
                  }
                </div>
                }
            </div>

          </div>

          <div class="form-group form-field-edit" *ngIf="addnewCampaignForm.get('messageSource').value == 'true'"  style="height: 75px">
                <label class="required search-label form-field-label" for="responseQueueIVRPrompts"
                  >Response Queue IVR Prompt</label
                >
                <select id="responseQueueIVRPrompts" class="inp" formControlName="responseQueueIVRPrompts">
                  <ng-container *ngFor="let item of responseQueueIVRPrompts">
                    <optgroup label="{{item.type}}">
                      <option [value]="item.value">{{ item.label }}</option>
                    </optgroup>
                  </ng-container>
                </select>
                @if (submitted && f['responseQueueIVRPrompts'].errors) {
                  <div class="text-danger label-error" >
                    @if (f['responseQueueIVRPrompts'].errors['required']) {
                    <small>ResponseQueueIVRPrompts is required</small>
                    }
                  </div>
                  }
              </div>
          <!-- @if (submitted && f['messageText'].errors) {
            <div class="text-danger label-error">
              @if (f['messageText'].errors['required']) {
              <small>MessageText is required</small>
              }
            </div>
            } -->
        </div>
       

        <div class="row crud-container" *ngIf="!isTextChannelSelected && machineDetectionAllowed">
          <div class="form-group form-field-edit">
            <label class="search-label form-field-label" for="messageSource">Machine Detection</label>
            <select id="machineDetection" class="inp" formControlName="MachineDetection">
              <ng-container *ngFor="let item of booleanOptions">
                <option
                  [value]="item.value"
                  [defaultSelected]="campaignDetail?.IVRPrompt?.Attributes?.IsMachineDetection === item.value"
                >
                  {{ item.label }}
                </option>
              </ng-container>
            </select>
          </div>
        </div>
      </div>

      <!------------ Section 4 ---------->
      <div class="details">
        <!--*ngIf="!isEdit || (isEdit && campaignDetail?.Status != 'Pending')"-->
        <div class="heading">
          <span class="section-heading">CONTACT DATA</span>
          <hr class="solid-divider" />
        </div>

        <div class="row crud-container">
          <div class="form-group form-field-edit">
            <label class="required search-label form-field-label" for="campaignDataType">Data Type</label>
            <select id="campaignDataType" class="inp" formControlName="campaignDataType">
              <ng-container *ngFor="let item of dataTypes">
                <option [value]="item.label">{{ item.label }}</option>
              </ng-container>
            </select>
            </div>
            @if (submitted && f['campaignDataType'].errors) {
              <div class="text-danger label-error" style="
              margin: -10px 0 0 -7px;
          ">
                @if (f['campaignDataType'].errors['required']) {
                <small>DataType is required</small>
                }
              </div>
              }
        </div>
      </div>
    </form>

    <div
      [ngStyle]="{
        'margin-top': isEdit && campaignDetail?.Status === 'Pending' ? '1rem' : 'inherit',
      }"
      class="details"
      *ngIf="isEdit"
    >
      <!-- <div class='heading'>
                <span class="sub-heading">CONTACT DATA</span>
                <hr class="solid-divider">
            </div> -->

      <div class="row crud-container" *ngIf="campaignDetail?.ContactFileID || dataFileProcess != ''">
        <div class="form-group form-field-edit">
          <label for="dataFileProcess" class="form-field-label">Data File Process</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control inp"
            id="dataFileProcess"
            placeholder="Data File Process"
            [(ngModel)]="dataFileProcess"
          />
        </div>
      </div>

      <div class="row crud-container" *ngIf="campaignDetail?.processResult">
        <div class="form-group form-field-edit inp-ta">
          <label for="processResult">Process Result</label>
          <textarea
            [readonly]="true"
            class="form-control padl-0"
            id="processResult"
            placeholder="Last Updated On"
            [(ngModel)]="campaignDetail.processResult"
          ></textarea>
        </div>
      </div>

      <div class="row crud-container mt-1 data-file-container" *ngIf="uploadedFiles.length == 0">
        <div class="form-group mt-1">
          <div class="data-file-div sub-heading"><span class="bold">Data File</span> (0 File, Max. 1)</div>
          <div class="col crud-container">
            <button
              *ngIf="!addNewFile"
              class="btn btn-outline-default blue-outline-btn btn-add-new"
              [disabled]="disableAllInputs"
              (click)="addNewFile = !addNewFile; savingDataFileMessage = ''"
            >
              Add New
            </button>
            <div *ngIf="addNewFile">
              <div class="form-group inp-file col-3 choose-file-div">
                <div>
                  <label class="choose-file"> Choose File
                    <input style="display: none;"
                      class="form-control file-upload"
                      type="file"
                      id="formFile"
                      (change)="handleDataFileInput($event)"
                    />
                  </label>
                </div>
                <div
                  *ngIf="addNewFile && savingDataFileMessage"
                  [ngClass]="{
                    loadingDotAnimation: savingDataFileMessage === 'Saving File',
                  }"
                  class="audio-timer"
                  style="top: 0.125rem"
                >
                  {{ savingDataFileMessage }}
                </div>
              </div>
              <div class="form-group col-7">
                <button
                  *ngIf="addNewFile"
                  class="btn btn-danger btn-cancel btn-add-new"
                  [disabled]="disableAllInputs"
                  (click)="addNewFile = !addNewFile"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row crud-container mt-1 data-file-container" *ngIf="uploadedFiles.length > 0">
        <ng-container *ngFor="let item of uploadedFiles">
          <div class="form-group mt-1">
            <div class="data-file-div">
              <span class="bold sub-heading">Data File</span>
              <span class="data-file-info"> ({{ uploadedFiles.length }} File, Max. 1)</span>
            </div>
            <div class="data-file-div" style="height: 4.5rem">
              <div class="data-file-doc col-3">
                <i class="bi bi-folder"></i>
                <span class="bold file-name">
                  {{
                    item.Name.length > fileNameMaxLenth ? (item.Name | slice: 0 : fileNameMaxLenth) + '...' : item.Name
                  }}
                </span>
                <div class="data-file-size">Size {{ formatBytes(item.Size) }}</div>
              </div>
            </div>
            <div class="col crud-container" *ngIf="campaignDetail?.Status === 'Pending' || campaignDetail?.Status === 'Ready'">
              <button
                *ngIf="!updateFile"
                class="btn btn-outline-default blue-outline-btn btn-add-new"
                [disabled]="disableAllInputs"
                style="float: left"
                (click)="updateFile = !updateFile; savingDataFileMessage = ''"
              >
                Update
              </button>
              <div *ngIf="updateFile">
                <div class="form-group form-field-edit col-3 inp-file choose-file-div">
                  <div>
                    <label class="choose-file"> Choose File
                      <input style="display: none;"
                        class="form-control file-upload"
                        type="file"
                        id="formFile"
                        (change)="handleDataFileInput($event)"
                      />
                    </label>
                  </div>
                  <div
                    *ngIf="updateFile && savingDataFileMessage"
                    [ngClass]="{
                      loadingDotAnimation: savingDataFileMessage === 'Saving File',
                    }"
                    class="audio-timer"
                    style="top: 0.125rem"
                  >
                    {{ savingDataFileMessage }}
                  </div>
                </div>
                <div class="form-group col-7">
                  <button
                    *ngIf="updateFile"
                    class="btn btn-danger btn-cancel btn-add-new"
                    [disabled]="disableAllInputs"
                    (click)="updateFile = !updateFile"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="row crud-container mt-1">
            <!-- *ngIf="campaignDetail.Status !== 'Pending' && campaignDetail.Status == 'Cancelled'"-->
            <div class="col-2 no-padding">
              <label class="file-format-template">File Description</label>
            </div>
            <div class="col-2">
              <label class="show-template" (click)="showFileDetails = !showFileDetails">
                Show/Hide
                <i *ngIf="showFileDetails" class="bi bi-chevron-up"></i>
                <i *ngIf="!showFileDetails" class="bi bi-chevron-down"></i>
              </label>
            </div>
            <div class="col-1">
              <button class="btn btn-outline-default blue-outline-btn mb-1" (click)="downloadBase64File(item)">
                Download
              </button>
            </div>
          </div>
          <div class="row crud-container" style="margin-top: 0.5rem" *ngIf="showFileDetails">
            <!--*ngIf="campaignDetail.Status !== 'Pending' && campaignDetail.Status == 'Cancelled'"-->
            <div class="file-details">Details</div>
            <table class="table file-details">
              <tbody>
                <tr>
                  <td style="width: 10%">ID</td>
                  <td>{{ item.FileID }}</td>
                </tr>
                <tr>
                  <td>Name</td>
                  <td>{{ item.Name }}</td>
                </tr>
                <tr>
                  <td>Description</td>
                  <td>{{ item.Description }}</td>
                </tr>
                <tr>
                  <td>Size</td>
                  <td>{{ formatBytes(item.Size) }}</td>
                </tr>
                <tr>
                  <td>URL</td>
                  <td>
                    <!-- <a href="{{ appBaseUrl + item.URL }}">{{ item.URL }}</a> -->
                    <span style="cursor: pointer; color: #0a58ca" (click)="downloadBase64File(item)">{{
                      item.Name
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <td>Disabled</td>
                  <td>{{ item.Disabled }}</td>
                </tr>
                <tr>
                  <td>Created</td>
                  <td>{{ item.Created | custdate }}</td>
                </tr>
                <tr>
                  <td>Last Updated</td>
                  <td>{{ item.LastUpdated | custdate }}</td>
                </tr>
                <tr>
                  <td>File Type</td>
                  <td>
                    {{ item.FileType.FileTypeGroupName }} - {{ item.FileType.Description }} ({{
                      item.FileType.Extensions[0]
                    }})
                  </td>
                </tr>
                <tr>
                  <td>Creator</td>
                  <td>{{ item.Creator.FirstName }} {{ item.Creator.LastName }}</td>
                </tr>
                <tr>
                  <td>Updater</td>
                  <td>{{ item.Updater.FirstName }} {{ item.Updater.LastName }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>
      </div>

      <div class="row crud-container">
        <div class="form-group form-field-edit">
          <label for="dataFileProcess" class="form-field-label label-blue">Records Loaded</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control inp"
            id="dataFileProcess"
            placeholder="Records Loaded"
            [value]="campaignDetail?.TotalRecords || 0"
          />
        </div>
      </div>

      <div class="row crud-container">
        <div class="col-2 no-padding" style="width: 10%">
          <label class="format-template sub-heading">Format Template</label>
        </div>
        <div class="col-2">
          <button
            class="btn btn-outline-default blue-outline-btn btn-add-new"
            (click)="downloadFile(baseHref + '/assets/Onvida_CampaignDataFileTemplate.csv')"
          >
            <i class="bi bi-download"></i> Download Sample CSV File
          </button>
        </div>
      </div>
    </div>
    <!------------ Section 5 ---------->
    <div class="details" *ngIf="isEdit && campaignDetail?.Status !== 'Pending' && campaignDetail?.Status !== 'Ready'">
      <div class="heading">
        <div class="row">
          <div class="col">
            <span class="section-heading">CAMPAIGN RESULTS</span>
          </div>
          <div class="col text-end path">Last Updated: {{ campaignDetail.LastUpdated | custdate }}</div>
        </div>
        <hr class="solid-divider" style="margin-top: -0.313rem" />
      </div>

      <div class="row crud-container mt-1">
        <div class="col-3 no-padding">
          <div class="progress-div row">
            <div class="col-3 results-message">Progress</div>
            <div class="col-9" style="width: 70%">
              <progress-bar progress="{{ progress }}" [color]="'#38d910'"> </progress-bar>
              <div *ngIf="campaignDetail?.Status === 'InProgress'" class="campaign-inprogress progressBar"></div>
            </div>
          </div>
        </div>
        <div class="col form-group"></div>
      </div>

      <div class="row crud-container">
        <div class="form-group form-field-edit">
          <label for="started" class="form-field-label">Started</label>
          <input
            type="text"
            class="form-control inp"
            id="started"
            placeholder="Started"
            [ngModel]="campaignDetail.Start | custdate"
            (ngModelChange)="campaignDetail.Start = $event"
          />
        </div>

        <div class="form-group form-field-edit">
          <label for="completed" class="form-field-label">Completed</label>
          <input
            type="text"
            class="form-control inp"
            id="completed"
            placeholder="Completed"
            [ngModel]="campaignDetail.End | custdate"
            (ngModelChange)="campaignDetail.End = $event"
          />
        </div>

        <div class="form-group form-field-edit">
          <label for="runningTime" class="form-field-label">Running Time</label>
          <input
            type="text"
            class="form-control inp"
            id="runningTime"
            placeholder="Running Time"
            [(ngModel)]="campaignDetail.RunningTime"
          />
        </div>

        <div class="form-group form-field-edit">
          <label for="callsMade" class="form-field-label">Calls Made</label>
          <input
            type="text"
            class="form-control inp"
            id="callsMade"
            placeholder="Calls Made"
            [(ngModel)]="campaignDetail.CallsMade"
          />
        </div>
      </div>

      <div class="row crud-container">
        <div class="form-group form-field-edit">
          <label for="failures" class="form-field-label">Failures</label>
          <input
            type="text"
            class="form-control inp"
            id="failures"
            placeholder="Failures"
            [(ngModel)]="campaignDetail.Failures"
          />
        </div>

        <div class="form-group form-field-edit">
          <label for="successes" class="form-field-label">Successes</label>
          <input
            type="text"
            class="form-control inp"
            id="successes"
            placeholder="Successes"
            [(ngModel)]="campaignDetail.Successes"
          />
        </div>

        <div class="form-group form-field-edit">
          <label for="responses" class="form-field-label">Responses</label>
          <input
            type="text"
            class="form-control inp"
            id="responses"
            placeholder="Responses"
            [(ngModel)]="campaignDetail.Responses"
          />
        </div>
      </div>

      <div class="row crud-container">
        <div class="form-group no-padding">
          <button *ngIf="!campaignDetail.IsDataFeed"  class="btn btn-outline-default blue-outline-btn mr-07 btn-add-new" (click)="showDetailsView()">
            View Details
          </button>
          <button class="btn btn-outline-default blue-outline-btn btn-add-new" (click)="refresh()" [disabled]="disableRefreshButton">
            <i class="bi bi-repeat"></i> Refresh
          </button>
        </div>
      </div>
    </div>
    <div class="row crud-container" style="margin-bottom: 3rem"></div>
  </div>
</div>
